import {BaseEntity} from "./BaseEntity";

export class Scanner implements BaseEntity {
    constructor(
        public id?:number,
        public deviceID?:string,
        public inactive?: string,
        public companyName?: string,
        public description?: string,
        public lastSeen?:string){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.deviceID = json.deviceID;
        this.inactive = json.inactive;
        this.companyName = json.companyName;
        this.description = json.description;
        this.lastSeen = json.lastSeen;
    }

}
